//import httpServe from '../../static/httpServe';
let global = {};
global.auth = true;
global.height = document.documentElement.clientHeight;
global.width = document.documentElement.clientWidth;
global.activeMenu = '0'; //当前激活的菜单项
global.fileurl = 'http://' + window.location.host + '/file/pub/upload';
global.imageMaxSize = 1024 * 1024 * 5; //图片大小限制：5M
global.imageMaxSizeText = '5M';
global.shareUrl = '';
global.isCollapse=false;
global.isagree=false;
export default global;



// WEBPACK FOOTER //
// ./src/utils/global.js